const constants = {
    ACTIONS : {
    GET_LP_LOADING : 'GET_LP_LOADING',
    GET_LP_PACKAGE : 'GET_LP_PACKAGE',
    GET_LP_FAIL : 'GET_LP_FAIL',
    GET_ALIAS_LP_LOADING : 'GET_ALIAS_LP_LOADING',
    GET_ALIAS_LP_PACKAGE : 'GET_ALIAS_LP_PACKAGE',
    GET_ALIAS_LP_FAIL : 'GET_ALIAS_LP_FAIL',
    LEAD_GENRATED_SUCCESS : 'LEAD_GENRATED_SUCCESS',
    LEAD_GENRATED_FAIL: 'LEAD_GENRATED_FAIL',

    }
}
export default constants;